import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListComponent } from './list/list.component';
import { DetailComponent } from './detail/detail.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GroupsComponent } from './groups/groups.component';
import { FamiliesListComponent } from './families-list/families-list.component';
import { FamiliesDetailComponent } from './families-detail/families-detail.component';
import { AddPersonExistingComponent } from './add-person-existing/add-person-existing.component';
import { ReportsComponent } from './reports/reports.component';
import { VisitListComponent } from './visit-list/visit-list.component';
import { VisitDetailComponent } from './visit-detail/visit-detail.component';
import { BackgroundChecksComponent } from './background-checks.component';
import { HouseholdsComponent } from './households/households.component';
import { DevExtremeModule, DxTemplateModule } from 'devextreme-angular';
import { VisitHouseholdComponent } from './visit-household/visit-household.component';
import { MembershipOverviewComponent } from './membership-overview/membership-overview.component';
import { NurseryOverviewComponent } from './nursery-overview/nursery-overview.component';
import { SundaySchoolOverviewComponent } from './sunday-school-overview/sunday-school-overview.component';
import { CommitteeOverviewComponent } from './committee-overview/committee-overview.component';
import { NominationOverviewComponent } from './nomination-overview/nomination-overview.component';
import { CalendarEventDialogComponent } from './calendar-event-dialog/calendar-event-dialog.component';
import { EventCalendarComponent } from './event-calendar/event-calendar.component';
import { SharedModule } from '../shared/shared.module';
import { BasicLayoutComponent } from '../common/layouts/basicLayout.component';
import { AuthGuard } from '../core/auth.guard';
import { PrepareGuard } from '../core/core.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        DevExtremeModule,
        DxTemplateModule,
        ListComponent,
        DetailComponent,
        GroupsComponent,
        HouseholdsComponent,
        FamiliesListComponent,
        FamiliesDetailComponent,
        ReportsComponent,
        VisitListComponent,
        BackgroundChecksComponent,
        VisitDetailComponent,
        VisitHouseholdComponent,
        AddPersonExistingComponent,
        MembershipOverviewComponent,
        NurseryOverviewComponent,
        SundaySchoolOverviewComponent,
        CommitteeOverviewComponent,
        NominationOverviewComponent,
        CalendarEventDialogComponent,
        EventCalendarComponent,
        RouterModule.forChild([
            {
                path: 'people',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    {
                        path: 'list',
                        component: ListComponent,
                        data: { title: 'People' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'groups',
                        component: GroupsComponent,
                        data: { title: 'Groups' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'households',
                        component: HouseholdsComponent,
                        data: { title: 'Households' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'families',
                        component: FamiliesListComponent,
                        data: { title: 'Families' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'families/:id',
                        component: FamiliesDetailComponent,
                        data: { title: 'Families' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'sunday-school',
                        component: SundaySchoolOverviewComponent,
                        data: { title: 'Sunday School' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'committees',
                        component: CommitteeOverviewComponent,
                        data: { title: 'Committees' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'nominations',
                        component: NominationOverviewComponent,
                        data: { title: 'Nominations' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'reports',
                        component: ReportsComponent,
                        data: { title: 'Reports' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'visits',
                        component: VisitListComponent,
                        data: { title: 'Visits' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'visit-household',
                        component: VisitHouseholdComponent,
                        data: { title: 'Visits By Household' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'membership-overview',
                        component: MembershipOverviewComponent,
                        data: { title: 'Membership Overview' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'nursery',
                        component: NurseryOverviewComponent,
                        data: { title: 'Nursery Overview' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'event-calendar',
                        component: EventCalendarComponent,
                        data: { title: 'Event Calendar' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'visits/:id',
                        component: VisitDetailComponent,
                        data: { title: 'Visits' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: 'background-checks',
                        component: BackgroundChecksComponent,
                        data: { title: 'Background Checks' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                    {
                        path: ':id',
                        component: DetailComponent,
                        data: { title: 'People' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [],
    exports: [AddPersonExistingComponent],
})
export class PeopleModule {}
